import { render, staticRenderFns } from "./Readmore.vue?vue&type=template&id=56dd606b&scoped=true"
import script from "./Readmore.vue?vue&type=script&lang=js"
export * from "./Readmore.vue?vue&type=script&lang=js"
import style0 from "./Readmore.vue?vue&type=style&index=0&id=56dd606b&prod&lang=css"
import style1 from "./Readmore.vue?vue&type=style&index=1&id=56dd606b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd606b",
  null
  
)

export default component.exports